export const MENUS_ITEMS = [
  {
    titleKey: 'legal_notices',
    type: 'link',
    url: 'legal',
  },
  {
    titleKey: 'terms_and_conditions',
    type: 'link',
    url: 'tos',
  },
  {
    titleKey: 'privacy_policy',
    type: 'link',
    url: 'privacy-policy',
  },
];
